(ns dashboard.utils
  (:require [clojure.string :as str]))

(defn str-includes-icase?
  "Like str/includes?, but case insensitive and nil tolerant"
  [s substr]
  (if (and (some? s) (some? substr))
    (str/includes? (str/lower-case s) (str/lower-case substr))
    false))

(defn lower-case
  "Like str/lower-case, but nil tolerant"
  [s]
  (str/lower-case (or s nil)))

(def excluded-word-prefix "-")

(defn excluded-word? [word]
  (str/starts-with? word excluded-word-prefix))

(defn parse-search-query
  "Parses a given query string into required and excluded words/phrases"
  [search-query]
  (when-not (str/blank? search-query)
    (let [search-query (-> search-query str/trim str/lower-case)
          ;; For the regex, see https://stackoverflow.com/questions/366202/regex-for-splitting-a-string-using-space-when-not-surrounded-by-single-or-double
          query-words (keep (fn [[word double-quoted single-quoted]]
                              (or double-quoted single-quoted word))
                            (re-seq #"[^\s\"]+|\"([^\"]*)\"" search-query))]
      {:required-words (remove excluded-word? query-words)
       :excluded-words (into []
                            (comp
                             (filter excluded-word?)
                             (map #(str/replace-first % excluded-word-prefix "")))
                            query-words)})))

;; TODO: If it turns out to be a problem, consider parsing the search query only once, and creating a matcher object.
;;      The current table search is a bit naive:
;;      For each item, the query is parsed and then a word match function is called for the parsed query.
;;      We could parse the query only once, then call the matcher for each item.
;;      This would change the API so that whenever the query changes, we would need to parse it, and store the result.
(defn match-search-query
  "Matches the words in a search query, with the given word-match-fn function.

  The \"-\" sign in front of a query word makes it excluded, it must not appear in the results.

  Words inside double quotes (\") are considered as a phrase, that should be contained in the match.

  Other query words are optional, but at least one of them has to match, if no required words are present."
  [search-query word-match-fn]
  (if-not (str/blank? search-query)
    (let [{:keys [required-words
                  excluded-words]} (parse-search-query search-query)]
      (and (if (seq required-words)
             (every? word-match-fn required-words)
             true)
           (if (seq excluded-words)
             (every? (complement word-match-fn) excluded-words)
             true)))
    true))

(defn debounce [f interval]
  (let [timeout-id (atom nil)]
    (fn [& args]
      (when @timeout-id
        (js/clearTimeout @timeout-id))
      (reset! timeout-id (js/setTimeout (fn [] (apply f args)) interval)))))
